import { CategoryData, PageMappingData, PlanData } from "types/models/planMaster/planMasterApp";
import { AppActions } from "../../types";
import { GET_Category, GET_PageMapping, GET_Plan, SET_Category_DATA, SET_PageMapping_DATA, SET_Plan_DATA,GET_PAGE_Plan, Plans_Count_Dashboard } from "types/actions/planMaster.action";

export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

// Initial state for plan
const initialState: {
  currentPlan: PlanData | null;
  plan: PlanData[];
  planCount: number;
  currentCategory: CategoryData | null;
  category: CategoryData[];
  categoryCount: number;
  currentPageMapping: PageMappingData | null;
  pageMapping: PageMappingData[];
  pageMappingCount: number;
  planPageData :PlanData[];
   dashboardCounts: {         // ✅ add this block
    totalPlans: 0,
    activePlans: 0,
    inactivePlans: 0,
    newPlans: 0,
  },
} = {
  currentPlan: null,
  plan: [],
  planCount: 0,
  currentCategory: null,
  category: [],
  categoryCount: 0,
  currentPageMapping: null,
  pageMapping: [],
  pageMappingCount: 0,
  planPageData:[],
   dashboardCounts: {         // ✅ add this block
    totalPlans: 0,
    activePlans: 0,
    inactivePlans: 0,
    newPlans: 0,
  },
};

const PlanMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    // Plan-related actions
    case GET_Plan:
      return {
        ...state,
        plan: action.payload.rows,
        planCount: action.payload.count,
      };
       case GET_PAGE_Plan:
      return {
        ...state,
        planPageData: action.payload,
      };
    case SET_Plan_DATA:
      return {
        ...state,
        currentPlan: action.payload,
      };
       // Category-related actions
    case GET_Category:
      return {
        ...state,
        category: action.payload.category,
        categoryCount: action.payload.categoryCount,
      };
    case SET_Category_DATA:
      return {
        ...state,
        currentCategory: action.payload,
      };
      // PageMapping-related actions
    case GET_PageMapping:
      return {
        ...state,
        pageMapping: action.payload.pageMapping,
        pageMappingCount: action.payload.pageMappingCount,
      };
    case SET_PageMapping_DATA:
      return {
        ...state,
        currentPageMapping: action.payload,
      };
      case Plans_Count_Dashboard:
      return {
        ...state,
        dashboardCounts: action.payload,
      };
    default:
      return state; 
  }
};

export default PlanMaster;
